<template>
  <div @click.stop="_ => $emit('click', _)"
       v-show="visible">
    <quill-editor
      v-if="mount"
      ref="editor"
      :id="`question-quill-editor${_uid}`"
      class="question-quill-editor"
      :style="style"
      :content="content"
      :options="options"
      :disabled="disabled"
      @change="change"/>
  </div>
</template>

<script>
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

import '@components/vue-quill-editor/formats/font'
import { Quill, quillEditor } from 'vue-quill-editor'
import PlainClipboard from './PlainClipboard'
const Clipboard = Quill.import('modules/clipboard')

export default {
  components: {QuillEditor: quillEditor},
  props: {},
  data () {
    return {
      visible: false,
      mount: false,
      content: '',
      options: {
        bounds: '#question-quill-editor' + this._uid,
        placeholder: this.placeholder,
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike', 'link'],
            [
              {
                'list': 'ordered',
              },
              {
                'list': 'bullet',
              },
            ],
            [{'header': [1, 2, 3, 4, 5, 6, false]}],
            [
              {'color': ['#f3605b', '#333']},
              {'background': ['#f3605b', '#333']}
            ],
            [{'align': []}],
            ['clean'],
          ],
        },
      },
      style: {},
      disabled: false,
      plainPaste: false,
    }
  },
  computed: {},
  watch: {
    visible (val) {
      // 每一次启动时，根据配置，启用不同的剪切板
      if (val) {
        Quill.register('modules/clipboard', this.plainPaste ? PlainClipboard : Clipboard, true)
      } else {
        // 恢复成默认的剪切板
        Quill.register('modules/clipboard', Clipboard, true)
      }
    }
  },
  created () {
    document.addEventListener('click', this.hide)
  },
  mounted () {},
  updated () {
    if (this.mount) {
      this.$nextTick(() => {
        // 计算编辑器容器最小高度
        $('.ql-container', this.$refs.editor.$el).height(
          $(this.$refs.editor.$el).outerHeight() - $('.ql-toolbar', this.$refs.editor.$el).outerHeight() - 2
        )
      })
    }
  },
  destroyed () {
    document.removeEventListener('click', this.hide)
  },
  methods: {
    change ({editor, html, text}) {
      if (this.content !== html) {
        this.content = html
      }
      this.callback({editor, html, text}, this)
    },
    hide () {
      this.visible = false
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
.question-quill-editor {
  position: absolute;
  background-color: white;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  overflow: hidden;
  width: 500px;

  &:hover {
    border-color: #c0c4cc;
  }

  .ql-container {
    font-size: inherit;
  }

  .ql-container.ql-snow {
    background-color: white;
    box-sizing: border-box;
    border: none;
    width: 100%;
    height: 100% !important;
  }

  .ql-toolbar.ql-snow {
    background-color: white;
    padding: 5px 15px;
    box-sizing: border-box;
    width: 100%;
    border: none;
    border-bottom: 1px solid #dcdfe6;
  }
}
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/question-editor/components/question-quill-editor/src/main.vue